<template>
    <div>
        <section class="page-banner page-banner-sec">
    		<h1 class="section-title " v-if="user">{{ $t('dashboard.header')}} {{user.first_name}}!</h1>
    	</section>
        <div id="layout-content" class="pt-4">

        	<div class="container">

                <div class="card-columns" style="column-count: 2;">

                    <div class="card">
                        <div class="card-header">{{ $t('dashboard.welcome_title')}}</div>
                        <div class="card-body">
                            <ClipLoader :loading="!enrolmentsLoaded" color="#5FB0E2" size="100px"></ClipLoader>
                            <div v-if="enrolmentsLoaded">
                                <p v-if="activeEnrollment">{{ $t('dashboard.contact_enrol.before')}} <router-link @click.native="displayEnrollmentHandler(activeEnrollment.id)" :to="{ name: 'therapy.display', params: { enrol_id: activeEnrollment.id } }" tag="a">{{activeEnrollment.program.display_name}} {{ $t('dashboard.contact_enrol.link_text')}}</router-link></p>
                                <p v-else>{{ $t('dashboard.contact_not_enrol.before')}} <router-link :to="{ name: 'therapy' }" tag="a">{{ $t('dashboard.contact_not_enrol.link_text')}}</router-link>{{ $t('dashboard.contact_not_enrol.after')}}</p>
                            </div>
                            <p>{{ $t('dashboard.logout.before')}} <router-link :to="{ name: 'logout' }" tag="a">{{ $t('dashboard.logout.link_text')}}</router-link> {{ $t('dashboard.logout.after')}}</p>
                        </div>

                        <div class="card-body p-3">
					<h4>{{ $t('dashboard.furthest_title')}}</h4>
                        <div v-if="furthest_visited_page && furthest_visited_page.title != null" @click="getFurthest()" :style="{ color: '#007bff', cursor: 'pointer' }">
                            <span>{{furthest_visited_page.title}}</span><br/>
                            <span v-if="furthest_visited_page.slide_position !=-1 && furthest_visited_page.p_type =='slideshows'" class="mr-1"> {{ $t('dashboard.SlidePosition') + ": "+ furthest_visited_page.slide_position +","}}</span>
                            <span v-html="formatDate(furthest_visited_page.last_visit_at)"></span>
                        </div>
                        <div v-else>
                            <p><em>No furthest page found.</em></p>
                        </div>
				</div>
                    </div>

                    <div class="card">
                        <div class="card-header">{{ $t('dashboard.messages_title')}}</div>
                        <div class="card-body">

                            <p>{{ $t('dashboard.messages_inbox.before')}} <router-link :to="{ name: 'messages' }" tag="a">{{ $t('dashboard.messages_inbox.link_text')}}</router-link> {{ $t('dashboard.messages_inbox.after')}}<br />
                                {{ $t('dashboard.messages_unread.before')}} <router-link :to="{ name: 'messages' }" tag="a">{{ $t('dashboard.messages_unread.link_text', { unread: inboxUnread })}}</router-link></p>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">{{ $t('dashboard.contacts_title')}}</div>
                        <div class="card-body">
                            <ClipLoader :loading="!matchingsLoaded" color="#5FB0E2" size="100px"></ClipLoader>
                            <p v-if="matchingsLoaded">
                                <span v-if="activeEnrollment && matchedUsers.length > 0">{{ $t('dashboard.contacts_text')}}</span>
                                <span  v-else>{{ $t('dashboard.contacts_text_no_match')}}</span>
                                
                                <ul v-if="activeEnrollment && matchedUsers.length > 0">
                                    <li v-for="(match, id) in matchedUsers"><router-link :to="{ name: 'messages.compose', query: { to: match.id } }" tag="a">{{ match.first_name }} {{ match.last_name }}</router-link></li>
                                </ul>
                                <ul v-else>
                                    <li><a :href="'mailto:'+$appConfig['unit_email']">{{ $appConfig['unit_email'] }}</a></li>
                                </ul>
                            </p>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">{{ $t('dashboard.login_title')}}</div>
                        <div class="card-body">
                            <p v-html="$t('dashboard.last_login', { last_login: formatDate(user.last_login) })"></p>
                            <p v-html="$t('dashboard.login_suspect', { email: $appConfig['unit_email'] })"></p>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'Dashboard',
    components: {
		ClipLoader: () => import ('vue-spinner/src/ClipLoader')
	},
    data () {
		return {
			enrolmentsLoaded: false,
            matchingsLoaded: false
		}
	},
    filters: {
        formatDate (value) {
			return moment(String(value)).format('MMM D, YYYY @ h:mma');
		}
    },
    computed: {
        ...mapGetters(["inboxUnread"]),
        user () {
            return this.$store.state.auth.user;
        },
        activeEnrollment () {
            let enrollments = this.$store.state.programs.enrollments;
            if (enrollments) {
                let keys = Object.keys(enrollments);
                let active = [];
                keys.forEach( function ( enrolId ) {
                    if ( enrollments[enrolId].terminated_at == null && moment().isAfter(moment(enrollments[enrolId].starts_at)) && moment().isBefore(moment(enrollments[enrolId].ends_at)) )
                        active.push(enrollments[enrolId]);
                });
                return (active[0]) ? active[0] : false;
            }
            return false;
        },
        matchedUsers () {
            return _.orderBy(this.$store.state.users.users, 'first_name');
        },
        client_id () {
            return this.user.id;
        },
        enrol_id () {
            return this.activeEnrollment.id;
        },
        furthest_visited_page() {
            if (this.$store.state.users.furthest_page && this.$store.state.users.furthest_page[this.client_id] && this.$store.state.users.furthest_page[this.client_id][this.enrol_id])
                {  
                    let key = Object.keys(this.$store.state.users.furthest_page[this.client_id][this.enrol_id])
                    return this.$store.state.users.furthest_page[this.client_id][this.enrol_id][key]
                }
            return false
        }

	},
    mounted() {
        this.currentUser();
        this.fetchForums({page: 1, per_page: 200});
        this.fetchEnrollments().then((v) => {
            this.enrolmentsLoaded = true; 
            this.fetchFurthestPageView({client_id: this.client_id,enrol_id: this.enrol_id});
            });
        this.fetchMatchings().then((v) => this.matchingsLoaded = true );
        this.getVideos({vtype: "global", clientId: this.currentUserId});
    },
    methods: {
        ...mapActions(["currentUser", "fetchEnrollments", "fetchMatchings", "enrollmentView", "fetchForums", "fetchFurthestPageView", "getVideos"]),
        formatDate (value) {
			return moment(String(value)).locale(this.$i18n.locale).format('MMM D, YYYY @ h:mma');
        },
        displayEnrollmentHandler(id) {
           this.enrollmentView(id).catch(errHandler);
        },
        getFurthest() {
            this.$router.push({ name: 'therapy.content', params: { enrol_id: this.furthest_visited_page.enrollment_id, stage_id: this.furthest_visited_page.stage_id, task_id: this.furthest_visited_page.task_id }, query: { position: this.furthest_visited_page.slide_position } });
        }
    }
}
</script>

<style>
@media (max-width: 500px) {
    .card-columns {
        -webkit-column-count: 1;
        -moz-column-count: 1;
        column-count: 1 !important;
    }
}
</style>
